module.exports = __webpack_public_path__ + "img/韭菜花田.9ca8fb70.jpg";